import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter';
import load from './base';
load();
